import * as __utils from "@utils";
import { config } from "@config";

export const InitializeApp = () => {
	mergeModules(_.utils, __utils);

	// set config.urls values that will be used throughout app from portal config values
	config.urls.cveApi = _.config.GetScheme('cve-api');

};

const mergeModules = (legacyModules, appModules) => {
	// Add the app imported modules to the portal's legacy global "_" modules (i.e. add __utils to _.utils)
	for (const key in appModules) legacyModules[key] = appModules[key];
};
